/**
 * 认证路由配置
 * @description 用户认证相关路由，包括登录、注册等
 */
import type { RouteRecordRaw } from 'vue-router'

const authRoutes: RouteRecordRaw[] = [
  {
    path: '/auth',
    name: 'Auth',
    redirect: '/auth/login',
    meta: {
      title: '用户认证',
      hideInMenu: true,
    },
    children: [
      {
        path: 'login',
        name: 'Login',
        component: () => import('@/views/auth/LoginView.vue'),
        meta: {
          title: '用户登录',
          requiresAuth: false,
          hideInMenu: true,
          breadcrumb: false,
        },
      },
      {
        path: 'register',
        name: 'Register',
        component: () => import('@/views/auth/RegisterView.vue'),
        meta: {
          title: '用户注册',
          requiresAuth: false,
          hideInMenu: true,
          breadcrumb: false,
        },
      },
      {
        path: 'forgot-password',
        name: 'ForgotPassword',
        component: () => import('@/views/auth/ForgotPasswordView.vue'),
        meta: {
          title: '找回密码',
          requiresAuth: false,
          hideInMenu: true,
          breadcrumb: false,
        },
      },
      {
        path: 'reset-password',
        name: 'ResetPassword',
        component: () => import('@/views/auth/ResetPasswordView.vue'),
        meta: {
          title: '重置密码',
          requiresAuth: false,
          hideInMenu: true,
          breadcrumb: false,
        },
      },
    ],
  },
]

export default authRoutes
